export const AppointmentLocationDisplay = ({ locationName }: { locationName?: string }) => {
  if (!locationName) return null

  return (
    <>
      <h4 style={{ marginBottom: "8px" }}>Location</h4>
      <p className="appointment-data">{locationName}</p>
    </>
  )
}
